
import { defineComponent } from 'vue';
import { ExclamationCircleIcon } from '@heroicons/vue/solid';
import { rules } from '@/constants';

const ruleMapping: any = {
  normalStr: rules.isNormalStr,
  url: rules.isUrl,
  address: rules.isAddress,
  symbol: rules.isSymbol,
  gtZero: rules.gtZero,
};

const errorMsgs: any = {
  normalStr: "Only type [0-9a-zA-Z] $-_.+!*'(), character",
  url: 'Invalid URL',
  address: 'Invalid address',
  symbol: '3~6 A-Z characters',
  gtZero: 'Must great than 0',
};

export default defineComponent({
  name: 'FormInput',
  emits: ['legal', 'update:modelValue'],
  data: () => ({
    text: '',
    legal: true,
    errorMessage: '',
  }),
  props: {
    name: {
      type: String,
    },
    required: {
      type: Boolean,
    },
    textarea: {
      type: Boolean,
    },
    modelValue: {
      type: String,
    },
    type: {
      type: String,
      default: 'text',
    },
    typeMode: {
      type: String,
    },
    autocomplete: {
      type: String,
      default: 'off',
    },
    placeholder: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
    rules: {
      type: Array,
    },
    rows: {
      type: String,
    },
    uppercase: Boolean,
    maxLength: { type: Number, default: 100000 },
    minLength: {
      type: Number,
      default: 0,
    },
    maxValue: Number,
    endTag: String,
  },
  components: {
    ExclamationCircleIcon,
  },
  mounted(this: any) {
    this.text = this.modelValue;
  },
  methods: {
    checkRule(val: any) {
      const words = val || this.text;

      let errorMsg = '';

      if (words === '' || words == undefined) {
        return this.required ? "Can't be empty" : '';
      }

      // Rule checking
      // Rule type: (val: string): boolean
      this.rules?.forEach((rule: any) => {
        if (errorMsg) {
          return;
        }
        if (!ruleMapping[rule](words)) {
          errorMsg = errorMsgs[rule];
        }
      });
      if (errorMsg) {
        return errorMsg;
      }

      if (words.length > this.maxLength) {
        return `Max ${this.maxLength} characters`;
      }
      if (words.length < this.minLength) {
        return `Min ${this.minLength} characters`;
      }
      if (this.maxValue && +words > this.maxValue) {
        return `No more than ${this.maxValue} ${this.endTag}`;
      }
      return '';
    },
    onHover() {
      if (!this.errorMessage) this.errorMessage = this.checkRule(this.text);
    },

    onInput(e: any) {
      let value = e.target.value;
      const key = e.data;
      let isInt = false;

      if (this.uppercase) {
        value = value.toUpperCase();
      }

      if (this.typeMode) {
        if (this.typeMode != 'FLOAT') {
          isInt = true;
        }
        value = value.replace(/[^\d.]/g, '');
        if (!/(\d|\.)/.test(key)) {
          value = value.substr(0, value.length - 1);
        } else {
          if (key == '.') {
            if (!isInt) {
              if (value == '.' || value == '0.') {
                value = '0.';
              } else {
                const res = value.match(/\./g);
                if (res && res.length > 1) {
                  value = value.substr(0, value.length - 1);
                }
              }
            } else {
              value = value.substr(0, value.length - 1);
            }
          }
          value = value.replace(/^0+/g, '0');
          if (
            value[0] == '0' &&
            value[1] !== '0' &&
            value[1] != '.' &&
            value[1] != undefined
          ) {
            value = value.substring(1);
          }
        }
      }

      this.text = value;
      this.$emit('update:modelValue', value);
      this.legal = true;
      this.errorMessage = '';
    },
  },

  watch: {
    // text(val: string) {
    //   let v = val;
    //   if (this.uppercase) {
    //     v = val.toUpperCase();
    //   }

    //   console.log(this.typeMode);

    //   this.$emit('update:modelValue', v);
    //   this.legal = true;
    //   this.errorMessage = '';
    // },
    modelValue(val: string) {
      this.text = val;
    },
  },
});
